import { FEE_ROUTER_PROGRAM_ID, LAMPORTS_PER_SOL_BIGINT } from "../lib/constants";
import { formatCompact, formatUsd } from "../lib/format";
import type { PlatformMetrics as PlatformMetricsData } from "../lib/metrics";

function solValue(lamports: bigint): number {
  return Number(lamports) / Number(LAMPORTS_PER_SOL_BIGINT);
}

function usdValue(sol: number, solUsdPrice?: number): string {
  if (!solUsdPrice) return "$—";
  const dollars = sol * solUsdPrice;
  return dollars > 0 && dollars < 0.01 ? "<$0.01" : formatUsd(dollars);
}

export function PlatformMetrics(props: {
  metrics: PlatformMetricsData;
  solUsdPrice?: number;
  loading: boolean;
  error?: string;
  onRefresh: () => void;
}) {
  const { metrics, solUsdPrice, loading, error, onRefresh } = props;
  const volumeSol = solValue(metrics.volumeLamports);
  const tribeFeeSol = solValue(metrics.tribeFeeLamports);
  const interfaceFeeSol = solValue(metrics.interfaceFeeLamports);
  return (
    <section className="platform-metrics panel" aria-label="Platform activity">
      <div className="metrics-heading">
        <div>
          <h2>Platform activity</h2>
          <span>{error ? "On-chain data unavailable" : "Verified from the fee router"}</span>
        </div>
        <div>
          <a
            href={`https://solscan.io/account/${FEE_ROUTER_PROGRAM_ID.toBase58()}`}
            target="_blank"
            rel="noreferrer"
          >
            View program ↗
          </a>
          <button onClick={onRefresh} disabled={loading}>{loading ? "Loading…" : "Refresh"}</button>
        </div>
      </div>
      <div className="metrics-grid">
        <div><span>Traders</span><strong>{formatCompact(metrics.traders, 0)}</strong><small>Unique wallets</small></div>
        <div><span>Trades</span><strong>{formatCompact(metrics.trades, 0)}</strong><small>{metrics.buys} buys · {metrics.sells} sells</small></div>
        <div><span>Total volume</span><strong>{usdValue(volumeSol, solUsdPrice)}</strong><small>{volumeSol.toFixed(6)} SOL</small></div>
        <div><span>Tribe fees</span><strong>{usdValue(tribeFeeSol, solUsdPrice)}</strong><small>{tribeFeeSol.toFixed(6)} SOL</small></div>
        <div><span>Interface fees</span><strong>{usdValue(interfaceFeeSol, solUsdPrice)}</strong><small>{interfaceFeeSol.toFixed(6)} SOL</small></div>
      </div>
    </section>
  );
}
